import React, { useEffect, useState } from 'react';
import './Loader.css';

const Loader = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 1800);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div className="loader-overlay">
      <div className="loader-content">
        <div className="loader-logo">SS</div>
        <div className="loader-text">Shri Sai Manpower Services</div>
        <div className="loader-bar">
          <div className="loader-fill" />
        </div>
      </div>
    </div>
  );
};

export default Loader;
